"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnreviewableReasons = exports.UNREVIEWABLE_ALERT_ID = void 0;
var UNREVIEWABLE_ALERT_ID = 'UNREVIEWABLE_APP_NOTIFICATION';
exports.UNREVIEWABLE_ALERT_ID = UNREVIEWABLE_ALERT_ID;
var UnreviewableReasons = {
  PUBLIC_USER: 'PUBLIC_USER',
  NOT_INSTALLED: 'NOT_INSTALLED',
  UNINSTALLED: 'UNINSTALLED',
  LIMIT_REACHED: 'LIMIT_REACHED',
  ALREADY_REVIEWED: 'ALREADY_REVIEWED',
  PROVIDER_USER: 'PROVIDER_USER',
  TEST_PORTAL_USER: 'TEST_PORTAL_USER'
};
exports.UnreviewableReasons = UnreviewableReasons;


//////////////////
// WEBPACK FOOTER
// ./js/constants/Reviewability.js
// module id = 273
// module chunks = 209 210 211 212